export const widgets = 'widgets'